require('../../scss/app-destinations.scss');

import Application from "./application";
import MobileMenuBehavior from "../behaviours/mobile-menu-behaviour";
import ShortlistCount from "../jsx/shortlist/shortlist-count";
import ShortlistButton from "../jsx/shortlist/shortlist-button";
import ToggleClassBehavior from "../behaviours/toggle-class-behaviour";
import ClassBehaviour from "../behaviours/class-behaviour";
import BlockEventBehaviour from "../behaviours/block-event-behaviour";



let config = {};

//Create Class to extend default behavior and tell it what react components to load.
config.behaviours = {
  "MobileMenuBehaviour": new MobileMenuBehavior(),
  'ToggleClassBehaviour': new ToggleClassBehavior(),
  'ClassBehaviour': new ClassBehaviour(),
  'BlockEventBehaviour': new BlockEventBehaviour(),
};

config.components = {
  "shortlist-count": ShortlistCount,
  "shortlist-button": ShortlistButton,
};

new Application(config);
